<script lang="ts">
    export let size: number,
        color: string,
        rotate: boolean = false
</script>

<svg
    fill="none"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    class:rotate
>
    <polyline style="stroke: {color}; stroke-width: 2px;" points="13 17 18 12 13 7" />
    <polyline style="stroke: {color}; stroke-width: 2px;" points="6 17 11 12 6 7" />
</svg>

<style>
.rotate {
  transform: rotate(180deg);
}
</style>
